interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}

export function SectionTitle({
  eyebrow,
  title,
  description,
  align = 'left',
  className = ''
}: SectionTitleProps) {
  return (
    <div
      className={`${align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-2xl'} ${className}`}
    >
      {eyebrow && <p className="section-label">{eyebrow}</p>}
      <h2 className="mt-2 text-balance text-3xl font-semibold tracking-[-0.035em] text-text-primary sm:text-4xl lg:text-[2.7rem] lg:leading-[1.08]">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-pretty text-base leading-7 text-text-secondary sm:text-lg">
          {description}
        </p>
      )}
    </div>
  );
}
